import { styled } from '@mui/material';
import { Button, Typography } from 'core/common/ui/ui-kit';
import Icon from 'core/svg-sprites/ui/Icon';

export const GoalWrapperStyled = styled('div')`
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 24px;
`;

export const GoalInfoStyled = styled('div')`
  display: flex;
  flex-direction: column;
  margin-left: 8px;
`;

export const TrialDisclaimerStyled = styled(Typography)`
  text-align: center;

  a {
    text-decoration: underline;
  }
`;

export const CardWrapperStyled = styled('div')`
  width: 100%;
  margin-bottom: 26px;
`;

export const CardHeaderStyled = styled('div')`
  padding: 4px 0;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  background: ${({ theme }) => theme.palette.background.secondary};
`;

export const CardBodyStyled = styled('div')`
  padding: 9px 20px 16px;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
  background: ${({ theme }) => theme.palette.contentBlockBackground.secondary};

  ${({ theme }) => theme.breakpoints.up('mobile')} {
    padding: 9px 70px 16px;
    background: ${({ theme }) => theme.palette.contentBlockBackground.main};
  }
`;

export const BodyHeaderStyled = styled('div')`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export const BodyHeaderPriceStyled = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.accent};
`;

export const TotalBlockStyled = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
`;

export const HorizontalLineStyled = styled('hr')`
  margin-top: 8px;
  border: 1px solid ${({ theme }) => theme.palette.background.accent};
`;

export const SubscriptionBlockStyled = styled('div')`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
`;

export const SubscriptionPricesBlockStyled = styled('div')`
  display: flex;
  align-items: flex-start;
`;

export const SubscriptionOldPriceStyled = styled(Typography)`
  align-self: flex-end;
  margin-right: 4px;
  text-decoration: line-through;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const SubscriptionActualPriceStyled = styled(Typography)`
  margin-left: 4px;
`;

export const ButtonStyled = styled(Button)`
  margin-bottom: 18px;
`;

export const GuaranteeBlockStyled = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
`;

export const GuaranteeIconStyled = styled(Icon)`
  flex-shrink: 0;
  margin-right: 8px;
  fill: ${({ theme }) => theme.palette.success.main};
`;
